// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { useVisualRefresh } from '../internal/hooks/use-visual-mode';
import ClassicAppLayout from './classic';
import { useAppLayoutFlagEnabled } from './utils/feature-flags';
import RefreshedAppLayout from './visual-refresh';
import ToolbarAppLayout from './visual-refresh-toolbar';
export const AppLayoutInternal = React.forwardRef((props, ref) => {
    const isRefresh = useVisualRefresh();
    const isToolbar = useAppLayoutFlagEnabled();
    if (isRefresh) {
        if (isToolbar) {
            return React.createElement(ToolbarAppLayout, { ref: ref, ...props });
        }
        else {
            return React.createElement(RefreshedAppLayout, { ref: ref, ...props });
        }
    }
    return React.createElement(ClassicAppLayout, { ref: ref, ...props });
});
//# sourceMappingURL=internal.js.map